import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({
  sidebarItems,
  activeMenuItem,
  handleMenuClick,
  setShowReportPage,
  setReportCandidateId,
  setShowFinalReportPage,
  setFinalReportCandidateId,
  isSidebarOpen,
}) => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const navigate = useNavigate();

 
  const resetReportViews = () => {
    setShowReportPage?.(false);
    setReportCandidateId?.(null);
    setShowFinalReportPage?.(false);
    setFinalReportCandidateId?.(null);
  };

  const handleMainMenuClick = (item) => {
    if (item.subItems) return;

    if (item.label !== 'Report' && item.label !== 'Final Report') {
      resetReportViews();
    }

    handleMenuClick(item.label);

    if (item.path) {
      navigate(item.path);
    }
  };

  const handleSubMenuClick = (subItem) => {
    const name = subItem.label || subItem;

    if (name !== 'Report' && name !== 'Final Report') {
      resetReportViews();
    }

    handleMenuClick(name);

    if (subItem.path) {
      navigate(subItem.path);
    }
  };

  return (
    <aside className={`user-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
      <nav>
        <ul className="sidebar-menu">
          {sidebarItems.map((item) => {
            const { icon: Icon, label, subItems } = item;

            return (
              <div
                key={label}
                className="sidebar-item-group"
                onMouseEnter={() => subItems && setHoveredMenu(label)}
                onMouseLeave={() => subItems && setHoveredMenu(null)}
              >
                <li
                  className={activeMenuItem === label ? 'active' : ''}
                  onClick={() => handleMainMenuClick(item)}
                >
                  <Icon className="sidebar-icon" />
                  <span>{label}</span>
                </li>

                {subItems && hoveredMenu === label && (
                  <ul className="sub-menu">
                    {subItems.map((subItem) => {
                      const name = subItem.label || subItem;

                      return (
                        <li
                          key={name}
                          className={activeMenuItem === name ? 'active' : ''}
                          onClick={() => handleSubMenuClick(subItem)}
                        >
                          <span>{name}</span>
                        </li>
                      );
                    })}
                  </ul>
                )}

                <div className="sidebar-divider"></div>
              </div>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
